import axios, { AxiosResponse } from "axios"
import { useState } from "react"
import NonLoginHeader from "../components/nonLoginHeader"
import '../home.scss'
import '../index.scss'
const SignIn = () =>{
    const [mailAddress, setMailAddress] = useState("")
    const [password, setPassword] = useState("")
    const handleMailAddress = (event:any) =>{
        setMailAddress(event.target.value)
    }
    type Response ={
        jwt:string
    }

    const BaseURL = "https://mega-api-web.azurewebsites.net/api/v1/users/signin"

    const handlePassword = (event:any) =>{
        setPassword(event.target.value)
    }
    const signInCheck = (event:any) =>{
        event.preventDefault()
        console.log(mailAddress,password)
        axios.post<[]>(BaseURL,
            {
                "email":mailAddress,
                "password":password
            },
            {
                headers: { "Content-type":"application/json"}
            }
        )
        .then((res:AxiosResponse) => {
            console.log(res.data.jwt);
            document.cookie = res.data.jwt;
            window.location.href = '/?#Refrigerator'
        }).catch((error) =>{
            console.log(error);
        });
    }
    return(
        <div className="signInBackGround">
            <NonLoginHeader/>
            <form onSubmit={signInCheck} className=" wrap mt-12">
                <div className="grid grid-rows-2 mx-auto overflow-x-hidden justify-center">
                    <input
                        value={mailAddress}
                        placeholder="メールアドレスを入力"
                        onChange={handleMailAddress}
                        className="border-2 my-6 px-6 text-center shadow-md rounded-full overflow-x-hidden"
                    />
                    <input
                        type="password"
                        value={password}
                        placeholder="パスワードを入力"
                        onChange={handlePassword}
                        className="border-2 my-6 px-6 text-center shadow-md rounded-full overflow-x-hidden"
                    />
                    <button type="submit"  className="mx-4 rounded-lg shadow-md bg-slate-200 border-2 max-w-11/12 my-6">サインイン</button>
                </div>

            </form>
            <div className="fire">
            <div className="flames">
                <div className="flame"></div>
                <div className="flame"></div>
                <div className="flame"></div>
                <div className="flame"></div>
            </div>
                <div className="logs"></div>
            </div>
        </div>
    )
}

export default SignIn